module.exports = __webpack_public_path__ + "img/early_intervention.409794e4.png";